function Step1() {
  var self = this;
  var widget;

  this.init = function () {

    this.validateApplication();
    this.bindEvents();

    // Initialise country/state fields independently of AddressFinder
    this.toggleStateField();

    // Make sure the address finder call is only applied on pages that our element exists on.
    if ($('#address_line1').length) {

      var initAddressFinder;
      widget, initAddressFinder = function() {
        widget = new AddressFinder.Widget(
          document.getElementById('address_line1'),
          'MR7WJD43FX8TACLBUNVH',
          'AU', {
            "address_params": {
              "post_box": "0"
            }
          }
        );

        /* Preselect the state option tag and default settings for the vic resident toggle*/
        if ($("#state").data('value')) {
          $("#state").val($("#state").data('value'));
          self.updateFloatingLabels();
        }

        $("#country").on("change", function () { 
          self.toggleStateField($(this).val()); 
        });

        widget.on('address:select', function(fullAddress, metaData) {
          document.getElementById('address_line1').value = metaData.address_line_1;
          if (typeof metaData.address_line_2 !== 'undefined') {
            document.getElementById('address_line2').value = metaData.address_line_2;
          }
          document.getElementById('suburb').value = metaData.locality_name;
          document.getElementById('state').value = metaData.state_territory;
          document.getElementById('postcode').value = metaData.postcode;

          self.updateFloatingLabels();
        });
        
      };

      this.downloadAddressFinder(initAddressFinder);
    }

    /* Show hide the donations block */
    this.toggleDonationsBlock();
    $('#toggle_donations').on('change', function () {
      self.toggleDonationsBlock();
    });

    /* Show hide the monetary & bookplate blocks */
    this.toggleDonationType();
    $('input[name="donation_type"]').on('change', function () {
      self.toggleDonationType();
    });

    /* Show hide the donation amount free text box */
    this.toggleOtherDonationAmount();
    $('input[name="donation_preset_amount"]').on('change', function () {
      self.toggleOtherDonationAmount();
    });
    
    this.toggleResearcherBenefits();
    $('#researcher').on('change', function () {
      self.toggleResearcherBenefits();
    });

  }

  this.toggleStateField = function (country) { 

    country = country || $("#country").data("value") || $("#country").val() || "Australia";    $("#country").val(country);

    if (country === "Australia") {
      $("#state_freetext").closest(".text-input").hide();
      $("#state").closest(".select-input-wrapper").show();

      if (!$("#state").val()) {
        $("#state").val("VIC").trigger("change");
      }

    } else { 
      $("#state").closest(".select-input-wrapper").hide(); 
      $("#state_freetext").closest(".text-input").show();

      if (widget && typeof widget.disable === "function") { 
        widget.disable(); 
      } 
    }
  };

  this.toggleDonationsBlock = function () {

    if ($('#toggle_donations').is(':checked')) {
      $('#donations_block').show();
    } else {
      $('#donations_block').hide();
    }

  };

  this.toggleOtherDonationAmount = function () {

    var $input = $('#donation_other_amount');
    var $wrapper = $input.closest('.text-input');

    if ($('#donation_amount_5').is(':checked')) {
      $wrapper.show();
      $input.focus();
    } else {
      $wrapper.hide();
      $input.val('');
    }

  };

  this.toggleDonationType = function () {

    var selectedType = $('input[name="donation_type"]:checked').val();

    var $monetary = $('#donation_monetary_amounts');
    var $bookplate = $('#donation_bookplate');

    if (selectedType === "1") {
      $monetary.show();
      $bookplate.hide();

      $('input[name="donation_bookplate_preset_amount"]').prop('checked', false);
      $('#bookplate_name').val('');
      $('#is_gift').prop('checked', false);
      
    } else if (selectedType === "2") {
      $monetary.hide();
      $bookplate.show();

      $('input[name="donation_preset_amount"]').prop('checked', false);
      $('#donation_other_amount').val('');
    } else {
      $monetary.hide();
      $bookplate.hide();
    }

  };

  this.toggleResearcherBenefits = function () {

    var isChecked = $('#researcher').is(':checked');

    $('#researcher-info').toggle(isChecked);

  };

  this.updateFloatingLabels = function () {

    $('.text-input input').each(function () {
      var $input = $(this);
      var $wrapper = $input.closest('.text-input');

      if ($input.val()) {
        $wrapper.addClass('has-value');
      } else {
        $wrapper.removeClass('has-value');
      }
    });

    $('.select-input select').each(function () {
      var $select = $(this);
      var $wrapper = $select.closest('.select-input');

      if ($select.val()) {
        $wrapper.addClass('has-value');
      } else {
        $wrapper.removeClass('has-value');
      }
    });

  };

  this.downloadAddressFinder = function (initAddressFinder) {
      var script = document.createElement('script');
      script.src = 'https://api.addressfinder.io/assets/v3/widget.js';
      script.async = true;
      script.onload = initAddressFinder;
      document.body.appendChild(script);
  };

  this.downloadEmailVerification = function (conf) {
    var e=document.createElement("script");
    e.src="https://api.addressfinder.io/assets/email/v1/widget.js",e.async=!0,
      e.onload=function(){
        new AddressFinder.Email.Widget(conf.addressSelector, conf.licenceKey, conf)}
      ,document.body.appendChild(e);
  };

  this.validateApplication = function () {

    jQuery.validator.addMethod('check_mobile', function(value, element, params) {

      if (!value) {
        return true;
      }

      value = value.replace(/\s/g, '');

      // Australian mobile number validation.
      if ($(params).val() === 'Australia') {
        return /^(\+614|614|04)\d{8}$/.test(value);
      }

      // International number: allow a reasonable range of
      // phone-number characters and lengths.
      return /^[+0-9().-]{5,25}$/.test(value);

    }, 'Please provide a valid phone number.');

    jQuery.validator.addMethod('email_filled', function(value, element,params) {

      if (value) {
        if ($("#email").val()) { return true; } else { return false; }
      } else { return true; }

    }, ' You must enter your email address to subscribe to our enewsletter.');

    jQuery.validator.addMethod("noHTMLtags", function(value, element){
      if(/<\/?[^>]+(>|$)/g.test(value)){
          return false;
      } else {
          return true;
      }
    }, ' HTML tags are not allowed.');

    jQuery.validator.addMethod("validDomain", function(value, element) {

      var bannedDomain = 'slv.vic.gov.au';
      const email = value.split("@");
  
      if (bannedDomain === email[1].toLowerCase()) { return false } else { return true }

    }, ' You cannot use an SLV email to become a member. Please provide a personal email address.');

    jQuery.validator.addMethod("strictEmail", function(value, element) {
      return this.optional(element) || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }, 'Enter an email address in the correct format, like name@example.com');

    jQuery.validator.addMethod("noPlusSymbol", function(value, element) {
  
      // Check if the email contains a plus symbol
      if (value.includes("+")) {
        return false;
      } else {
        return true;
      }
    
    }, ' Email addresses cannot contain a "+" symbol.');

    jQuery.validator.addMethod("validYearOfBirth", function(value, element) {

      // allow empty field
      if (this.optional(element)) {
        return true;
      }

      // must be 4 digits
      if (!/^\d{4}$/.test(value)) {
        return false;
      }

      var year = parseInt(value, 10);
      var currentYear = new Date().getFullYear();

      var minYear = 1850;
      var maxYear = currentYear;

      return year >= minYear && year <= maxYear;

    }, 'Enter a valid year of birth.');

    var formHasBeenSubmitted = false;

    $("#step1").validate({

      ignore: ":hidden",
      onkeyup: false,

      highlight: function(element) {
        if (!formHasBeenSubmitted) return;

        if (element.type === "radio") {
          $(element)
            .closest('.donation-group')
            .addClass('invalid');
        } else {
          $(element)
            .closest('.text-input')
            .addClass('invalid');
        }
      },

      unhighlight: function(element) {
        if (!formHasBeenSubmitted) return;

        if (element.type === "radio") {
          var group = $(element).closest('.donation-group');

          // only mark valid if one is checked
          if ($('input[name="' + element.name + '"]:checked').length) {
            group.removeClass('invalid');
          }
        } else {
          $(element)
            .closest('.text-input')
            .removeClass('invalid');
        }
      },

      /*  ios8 & above only scroll back to the focus of the first error. If you hit submit again & there is another error
          it will not scroll. This confuses the user as they do not think there is another error message. This code fixes that. */
      invalidHandler: function(e, validator) {
        formHasBeenSubmitted = true;

        if (window.navigator.userAgent.match(/iphone/i)) {
          window.setTimeout(function() {

            var el = $(validator.errorList[0].element);

            var target = el.attr("type") === "radio"
              ? el.closest('.donation-group')
              : el;

            $("html,body").animate({
              scrollTop: target.offset().top
            });

          }, 0);
        }
      },

      errorPlacement: function(error, element) {
        error.addClass('input-error caption');

        if (element.attr("type") === "radio") {
          error.insertAfter(element.closest('.donation-group'));
        } else {
          var wrapper = element.closest('.text-input-wrapper');
          var description = wrapper.find('.input-description');

          if (description.length) {
            error.insertBefore(description);
          } else {
            wrapper.append(error);
          }
        }
      },

      rules: {
        first_name: {
          noHTMLtags: true
        },
        last_name: {
          noHTMLtags: true
        },
        email: {
          validDomain: true,
          noPlusSymbol: true,
          strictEmail: true
        },
        year_of_birth: {
          validYearOfBirth: true,
          noHTMLtags: true
        },
        staff_number: {
          noHTMLtags: true
        },
        phone: {
          noHTMLtags: true,
          check_mobile: '#country'
        },
        donation_other_amount: {
          required: true
        },
        address_line1: {
          noHTMLtags: true
        },
        address_line2: {
          noHTMLtags: true
        },
        suburb: {
          noHTMLtags: true
        },
        state: {
          noHTMLtags: true
        },
        postcode: {
          noHTMLtags: true
        },
        country: {
          noHTMLtags: true
        },
        donation_preset_amount: {
          required: {
            depends: function (element) {
              var type = $('input[name="donation_type"]:checked').val();

              if (type == "1") {
                return $(element).closest('#donation_monetary_amounts').length > 0;
              }

              if (type == "2") {
                return $(element).closest('#donation_bookplate').length > 0;
              }

              return false;
            }
          }
        }
      },

      messages: {
        donation_other_amount: {
          required: 'Enter a donation amount, like 25',
          min: 'Donation amount must be 1 or more'
        },
        first_name: {
          required: 'Enter your given name'
        },
        last_name: {
          required: 'Enter your family name'
        },
        year_of_birth: {
          pattern: 'Enter only numbers for your year of birth'
        },
        email: {
          required: 'Enter your email address',
          email: 'Enter an email address in the correct format, like name@example.com'
        },
        staff_number: {
          required: 'Enter your staff or volunteer number'
        },
        phone: {
          required: 'Enter your phone number',
          pattern: 'Phone number must only include digits 0 to 9, hyphens, plus, spaces and brackets'
        },
        address_line1: {
          required: 'Enter your address line 1'
        },
        suburb: {
          required: 'Enter your suburb/town'
        },
        state: {
          required: 'Enter your state'
        },
        postcode: {
          required: 'Enter your postcode'
        },
        country: {
          required: 'Enter your country'
        },
        donation_preset_amount: {
          required: function() {
            if (parseInt($('form input[type=radio][name=donation_type]:checked').val()) == 2) {
              return 'Select a bookplate';
            } else {
              return 'Select a donation amount';
            }
          }
        },
        bookplate_name: {
          required: 'Enter the bookplate name'
        }
      },

      submitHandler: function(form) {

        // Disable the submit button to prevent multiple clicks
        var $submitButton = $(form).find('button[type="submit"]');
        $submitButton.prop('disabled', true);
        
        grecaptcha.ready(function() {
          grecaptcha.execute('6LeP_rkUAAAAAO2GHVS31IwO4Zquu0aA7F0ZSYpc', {action: 'homepage'}).then(function(token) {
            jQuery('#step1').prepend('<input type="hidden" name="g-recaptcha-response" value="' + token + '">');
            form.submit();
          }).catch(function(error) {
            // In case of an error, re-enable the submit button
            $submitButton.prop('disabled', false);
          });
        });

      }

    });

  }

  this.toggle = function(className, obj) {
    var $input = $(obj);
    if ($input.prop('checked')) $(className).show();
    else $(className).hide();
  }

  this.bindEvents = function () {

    $("#back-to-landing").on('click',function() {
      window.location = "https://www.slv.vic.gov.au/";
    });

    $(".text-input input").each(function () {
      var $input = $(this);
      var $field = $input.closest(".text-input");

      // INITIAL VALUE (for prefilled inputs)
      if ($input.val().length > 0) {
        $field.addClass("has-value");
      }

      // FOCUS
      $input.on("focus", function () {
        $field.addClass("focused");
      });

      // BLUR
      $input.on("blur", function () {
        $field.removeClass("focused");
      });

      // INPUT (handles typing, paste, etc.)
      $input.on("input", function () {
        if ($input.val().length > 0) {
          $field.addClass("has-value");
        } else {
          $field.removeClass("has-value");
        }
      });
    });

    $(".select-input select").each(function () {
      var $select = $(this);
      var $field = $select.closest(".select-input");

      // INITIAL VALUE
      if ($select.val() && $select.val().length > 0) {
        $field.addClass("has-value");
      }

      // CHANGE (select uses change, not input)
      $select.on("change", function () {
        if ($select.val() && $select.val().length > 0) {
          $field.addClass("has-value");
        } else {
          $field.removeClass("has-value");
        }
      });

      // OPTIONAL: focus styling consistency
      $select.on("focus", function () {
        $field.addClass("focused");
      });

      $select.on("blur", function () {
        $field.removeClass("focused");
      });
    });
  

  }

}

module.exports = Step1;
